// Pe iPhone, la tastatură Safari derulează documentul ca să arate câmpul, chiar dacă acesta stă
// într-o ramă fixă (mesajele, popup-urile) — și pe <html> cu overflow: hidden. După ce tastatura
// se închide, derularea rămâne: elementele fixe (sticla, foile) se desenează în alt loc decât cel
// în care primesc atingerile. Câmpurile din rame fixe n-au de ce să miște pagina, așa că la
// închiderea tastaturii o readucem unde era înainte de focus.

const TEXT_INPUT_TYPES = new Set([
   "",
   "text",
   "search",
   "email",
   "url",
   "tel",
   "password",
   "number",
   "date",
   "datetime-local",
   "month",
   "time",
   "week",
]);

// după închiderea tastaturii Safari mai ajustează derularea cât durează animația ei: încercăm
// de câteva ori, ultima oară uităm poziția
const RESTORE_AT_MS = [0, 350, 700];

function isTextField(el) {
   if (!(el instanceof HTMLElement)) return false;
   if (el.isContentEditable) return true;
   const tag = el.tagName;
   if (tag === "TEXTAREA") return true;
   if (tag === "INPUT") {
      return TEXT_INPUT_TYPES.has(String(el.getAttribute("type") || "").toLowerCase());
   }
   return false;
}

function isInsideFixed(el) {
   for (let node = el; node && node !== document.body; node = node.parentElement) {
      if (window.getComputedStyle(node).position === "fixed") return true;
   }
   return false;
}

export function bootstrapIosKeyboardScrollRestore() {
   if (typeof window === "undefined" || !window.matchMedia) return;
   if (!window.matchMedia("(hover: none) and (pointer: coarse)").matches) return;

   let saved = null;
   let timers = [];

   const clearTimers = () => {
      timers.forEach((id) => window.clearTimeout(id));
      timers = [];
   };

   const restore = () => {
      if (!saved || isTextField(document.activeElement)) return;
      if (window.scrollX !== saved.x || window.scrollY !== saved.y) {
         window.scrollTo(saved.x, saved.y);
      }
   };

   document.addEventListener(
      "focusin",
      (event) => {
         if (!isTextField(event.target)) return;
         clearTimers();
         // trecerea dintr-un câmp în altul păstrează poziția de dinaintea primului
         if (saved) return;
         if (!isInsideFixed(event.target)) return;
         saved = { x: window.scrollX, y: window.scrollY };
      },
      true,
   );

   document.addEventListener(
      "focusout",
      () => {
         if (!saved) return;
         clearTimers();
         const last = RESTORE_AT_MS[RESTORE_AT_MS.length - 1];
         timers = RESTORE_AT_MS.map((ms) =>
            window.setTimeout(() => {
               if (isTextField(document.activeElement)) return;
               restore();
               if (ms === last) saved = null;
            }, ms),
         );
      },
      true,
   );

   // tastatura se închide (vizualul revine la înălțimea întreagă) după ce focusul a plecat
   window.visualViewport?.addEventListener?.("resize", () => {
      if (!saved || isTextField(document.activeElement)) return;
      if (window.visualViewport.height >= window.innerHeight - 1) restore();
   });
}
